import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { FormArrayItem } from '@app/components/form/array/FormArrayItem';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { TagGroupsFormValues } from '../types';
import { TagGroupContent } from './TagGroupContent';

export function TagGroupsFormContent() {
  const { $t } = useIntl();
  return (
    <Stack spacing={3}>
      <FormArrayItem<TagGroupsFormValues>
        name="tagGroups"
        // title="Grupos de tags"
        defaultItem={{
          name: '',
          tags: [],
          default: false,
        }}
        deleteConfirmation={{
          title: $t({
            id: 'admin.tagGroups.deleteGroupTitle',
            defaultMessage: 'Eliminar grupo',
          }),
          description: () =>
            $t({
              id: 'admin.tagGroups.deleteGroupConfirm',
              defaultMessage: '¿Estás seguro que deseas eliminar el grupo?',
            }),
        }}
        getItemDisplayName={(item) =>
          item?.name ||
          $t({
            id: 'admin.tagGroups.newGroupName',
            defaultMessage: 'Nuevo grupo',
          })
        }
        renderItem={({ index }) => <TagGroupContent index={index} />}
      />

      <FormActionsMui
        saveLabel={$t({
          id: 'common.actions.save',
          defaultMessage: 'Guardar',
        })}
      />
    </Stack>
  );
}
